// extracted by mini-css-extract-plugin
export default {"main-div":"App_main-div__63oUp"};